export default "__VITE_ASSET__14fb1c2c__"